import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard } from 'core/auth-guard/auth-guard.service';
import { MobileGuard } from 'core/mobile-guard/mobile.guard.service';
import { UnsavedChangesGuard } from 'core/unsaved-changes/unsaved-changes-guard.class';
import { NsLocaleGuard } from 'core/ns-locale-guard/ns-locale.guard';
import { AccountsDetailComponent } from './accounts/accounts-detail/accounts-detail.component';
import { AccountsListTableComponent } from './accounts/accounts-list/accounts-list-table/accounts-list-table.component';
import { ContactsDashboardComponent } from './contacts/contacts-dashboard/contacts-dashboard.component';
import { DashboardComponent } from './dashboard/dashboard.component';
import { LeadsComponent } from './leads/leads.component';
import { TouchpointsComponent } from './touchpoints/touchpoints.component';
import { ViewOfflineStatusComponent } from './view-offline-status/view-offline-status.component';
import { PowerBiReportComponent } from './dashboard/power-bi-report/power-bi-report.component';
import { B2bEditCartComponent } from './b2b-users/b2b-edit-cart/b2b-edit-cart.component';

const routes: Routes = [
  { path: 'leads/lead/:leadId', component: LeadsComponent, canActivate: [NsLocaleGuard], canDeactivate: [UnsavedChangesGuard] },
  {
    path: 'leads/lead/edit/:leadId',
    component: LeadsComponent,
    canActivate: [NsLocaleGuard],
    canDeactivate: [UnsavedChangesGuard]
  },
  {
    path: 'leads/delivery-location/edit/:leadId',
    component: LeadsComponent,
    canActivate: [NsLocaleGuard],
    canDeactivate: [UnsavedChangesGuard]
  },
  {
    path: 'leads/:customerId/lead-delivery/:leadId',
    component: LeadsComponent,
    canActivate: [NsLocaleGuard],
    canDeactivate: [UnsavedChangesGuard]
  },
  { path: 'leads/leads-management/new', component: LeadsComponent, canActivate: [NsLocaleGuard], canDeactivate: [UnsavedChangesGuard] },
  { path: 'leads', component: LeadsComponent, canActivate: [NsLocaleGuard] },
  {
    path: 'accounts/:customerId/contacts/:contactId',
    component: ContactsDashboardComponent, canActivate: [NsLocaleGuard], canDeactivate: [UnsavedChangesGuard]
  },
  {
    path: 'accounts-leads/:leadId/contacts/:contactId',
    component: ContactsDashboardComponent, canActivate: [NsLocaleGuard], canDeactivate: [UnsavedChangesGuard]
  },
  { path: 'accounts/:customerId/b2b-cart', component: B2bEditCartComponent, canActivate: [NsLocaleGuard] },
  { path: 'accounts/:customerId', component: AccountsDetailComponent, canActivate: [NsLocaleGuard] },
  { path: 'accounts-leads/:leadId', component: AccountsDetailComponent, canActivate: [NsLocaleGuard] },
  { path: 'accounts', component: AccountsListTableComponent, canActivate: [AuthGuard, NsLocaleGuard] },
  { path: 'touchpoints', component: TouchpointsComponent, canActivate: [AuthGuard, NsLocaleGuard] },
  { path: '', component: DashboardComponent, canActivate: [AuthGuard, MobileGuard, NsLocaleGuard] },
  { path: 'dashboard', component: DashboardComponent, canActivate: [AuthGuard, NsLocaleGuard] },
  { path: 'dashboard/reports', component: PowerBiReportComponent, canActivate: [AuthGuard, NsLocaleGuard] },
  { path: 'dashboard/tableau', redirectTo: 'dashboard/reports', pathMatch: 'full' },
  { path: 'applicationStatus/:tabName', component: ViewOfflineStatusComponent, canActivate: [NsLocaleGuard] }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class CrmRoutingModule { }
